import * as exBootstrap from '../../bootstrap';

// ----------------------------------------------------------------------------

function show(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.show('Popovers', element, config);
}

function hide(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.hide('Popovers', element, config);
}

function toggle(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.toggle('Popovers', element, config);
}

// ----------------------------------------------------------------------------

export { show, hide, toggle };
